<script>
    export let disabled = false
    export let buttonType = 'primary'
    export let type = 'button'
    
    let btnStyle
    
    $: if (buttonType === 'secondary') {
        if (disabled) {
            btnStyle = 'opacity-50 bg-light-navy text-white hover:bg-light-navy transition duration-150'
        } else {
            btnStyle = 'bg-light-navy text-white hover:bg-primary-blue transition duration-150'
        }
    } else if (buttonType === 'success') {
        if (disabled) {
            btnStyle = 'opacity-50 bg-success-green text-white'
        } else {
            btnStyle = 'bg-success-green text-white'
        }
    } else {
        if (disabled) {
            btnStyle = 'opacity-50 bg-white text-light-navy hover:bg-white hover:text-white transition duration-150'
        } else {
            btnStyle = 'bg-white text-light-navy hover:bg-primary-blue hover:text-white transition duration-150' 
        }
    }
</script>

<button
    on:click
    type={type}
    disabled={disabled}
    class="{btnStyle} px-4 py-2 uppercase rounded-lg shadow-lg text-sm font-semibold">
    <slot />
</button>